import { styled } from 'twin.macro';

const MarkdownTableBody = styled.tbody``;

export default MarkdownTableBody;
